import { Controller } from "@hotwired/stimulus"

// Периодически обновляет блок статуса подключения мессенджера (connection_status_inner partial)
// через Turbo Stream, пока аккаунт находится в промежуточном состоянии.
//
// ВАЖНО: этот контроллер живёт на ВНЕШНЕМ wrapper-div (id="messenger_account_poller_*"),
// который НЕ заменяется Turbo Stream. Заменяется только INNER div (id="messenger_account_status_*").
// Это предотвращает цепную реакцию: poll → replace → disconnect/connect → poll → ...
//
// Polling останавливается когда statusTarget получает data-done="true"
// (т.е. статус стал финальным: connected / error / disconnected).
//
// Использование:
//   <div data-controller="connection-poller"
//        data-connection-poller-url-value="/messenger_accounts/:id/connection_status"
//        data-connection-poller-interval-value="4000">
//     <div data-connection-poller-target="status" data-done="false"> ... </div>
//   </div>
//
export default class extends Controller {
  static targets = ["status"]
  static values = {
    url: String,
    interval: { type: Number, default: 4000 },
  }

  connect() {
    this.timer = null
    // Не делаем немедленный poll — начальный статус уже отрендерен сервером.
    // Если статус уже финальный — вообще не стартуем.
    if (!this.isDone()) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (this.timer) return
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  isDone() {
    return this.hasStatusTarget && this.statusTarget.dataset.done === "true"
  }

  currentSignature() {
    if (!this.hasStatusTarget) return null
    return this.statusTarget.dataset.connectionStatusSignature || null
  }

  async poll() {
    // Если статус уже финальный — остановить polling
    if (this.isDone()) {
      this.stopPolling()
      return
    }
    if (!this.urlValue) return
    try {
      const headers = {
        Accept: "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest",
      }
      const currentSignature = this.currentSignature()
      if (currentSignature) {
        headers["X-Connection-Status-Signature"] = currentSignature
      }

      const response = await fetch(this.urlValue, {
        headers,
        credentials: "same-origin",
      })
      if (response.status === 204) {
        return
      }
      if (response.ok) {
        const text = await response.text()
        if (text && text.trim()) {
          Turbo.renderStreamMessage(text)
        }
        // После обновления DOM проверяем, не стал ли статус финальным
        if (this.isDone()) {
          this.stopPolling()
        }
      }
    } catch (_e) {
      // Игнорируем ошибки сети — следующий poll попробует снова
    }
  }
}
